import { BlogHero } from '@/components/blog/BlogHero'
import { BlogComingSoon } from '@/components/blog/BlogComingSoon'

export const BlogPage = () => (
  <>
    <BlogHero />

    <BlogComingSoon />
  </>
)
